import React, { createContext, useContext, useState, useEffect } from 'react';

const FiltersContext = createContext(null);

export const FiltersProvider = ({ children }) => {
    const [isFiltersShown, setIsFiltersShown] = useState(false);

    return (
        <FiltersContext.Provider
            value={{
                isFiltersShown,
                setIsFiltersShown,
            }}>
            {children}
        </FiltersContext.Provider>
    );
};

export const useFilters = () => {
    const context = useContext(FiltersContext);
    if (!context) {
        throw new Error('useFilters must be used within a FiltersProvider');
    }
    return context;
};

export default FiltersProvider;
